module.exports = __webpack_public_path__ + "media/images/prediction/bnr_prediction_yahagi-4cf9c67c695ef5042ab71690216160be.jpg";